export const DEEPMATCH_CONFIG_GROUP = 'DeepMatch';
export const DEEPMATCH_CONFIG_NAME = 'DeepMatchWeights';

export const DEEPMATCH_WEIGHTS_CLAIM = `${DEEPMATCH_CONFIG_GROUP}.${DEEPMATCH_CONFIG_NAME}`;

export interface DeepMatchPriorityWeights {
  workPlace: number;
  companyDomain: number;
  language: number;
  relocation: number;
  employmentType: number;
  education: number;
  userSkillValidation: number;
  hardSkills: number;
  softSkills: number;
  requiredExperience: number;
  salary: number;
  verifiedUser: number;
  companySize: number;
}

export interface DeepMatchEffectiveSettings {
  source?: string;
  weights: DeepMatchPriorityWeights;
}
